export default function LotCard({ lot, onClick, compact = false, unread = false }) {
  return (
    <div
      onClick={() => onClick(lot)}
      style={{
        position: "relative",
        cursor: "pointer",
        border: "1px solid #e5e7eb",
        borderRadius: compact ? "10px" : "16px",
        padding: compact ? "0.75rem" : "1rem",
        background: "white",
        transition: "all 0.2s ease",
        width: compact ? "240px" : "auto",
        minWidth: compact ? "240px" : "auto",
        minHeight: compact ? "128px" : "auto",
        boxSizing: "border-box"
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.08)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <div
        style={{
          fontSize: compact ? "1rem" : "1.2rem",
          fontWeight: 700,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}
        title={`Lotto: ${lot.lotto}`}
      >
        Lotto: {lot.lotto}
      </div>

      {unread && (
        <div
          title="Nuovi messaggi"
          style={{
            position: "absolute",
            top: compact ? "0.65rem" : "0.85rem",
            right: compact ? "0.65rem" : "0.85rem",
            width: "12px",
            height: "12px",
            borderRadius: "999px",
            background: "#dc2626",
            border: "2px solid #ffffff",
            boxShadow: "0 0 0 1px rgba(220, 38, 38, 0.28)",
            boxSizing: "border-box"
          }}
        />
      )}

      <div style={{ color: "#6b7280", fontSize: compact ? "0.85rem" : "1rem" }}>
        {lot.numeroOrdini} ordini - {lot.numeroClienti} clienti
      </div>

      <div
        style={{
          marginTop: "0.5rem",
          fontSize: compact ? "0.8rem" : "0.9rem",
          color: "#374151",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}
        title={lot.operai?.length ? lot.operai.join(", ") : "-"}
      >
        Operai: {lot.operai?.length ? lot.operai.join(", ") : "-"}
      </div>

      <div
        style={{
          marginTop: "0.5rem",
          fontSize: compact ? "0.78rem" : "0.85rem",
          color: "#9ca3af"
        }}
      >
        Consegna:{" "}
        {lot.prossimaConsegna
          ? new Date(lot.prossimaConsegna).toLocaleDateString("it-IT")
          : "-"}
      </div>
    </div>
  );
}
